import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import AgentCashBackEdit from '../edit/index';
export default {
  name: 'AgentCashBackList',
  components: {
    AgentCashBackEdit: AgentCashBackEdit
  },
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('cash_back_select'),
      isCreate: this.checkauthority('cash_back_create'),
      isUpdate: this.checkauthority('cash_back_update'),
      isDelete: this.checkauthority('cash_back_delete'),
      isExport: this.checkauthority('cash_back_export'),
      selectForm: {
        createTimes: [],
        selectCitys: [],
        memberNo: ''
      },
      citys: [],
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      props: {
        multiple: true
      }
    };
  },
  methods: {
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        selectCitys: this.selectForm.selectCitys,
        memberNo: this.selectForm.memberNo
      };
      if (this.selectForm.createTimes.length >= 2) {
        par.createStartTime = this.selectForm.createTimes[0];
        par.createEndTime = this.selectForm.createTimes[1];
      }
      var apiUrl = 'admin/v1/agentCashBack/exportPageList';
      this.downloadUtil.excelExport(apiUrl, par, '返现记录表.xls');
    },
    getImagesImage: function getImagesImage(row) {
      var url = JSON.parse(row.bankBackOrder)[0].url;
      return this.downloadUrl + url;
    },
    getImagesImages: function getImagesImages(row) {
      var _this = this;
      var images = JSON.parse(row.bankBackOrder);
      var urls = [];
      images.forEach(function (img) {
        urls.push(_this.downloadUrl + img.url);
      });
      return urls;
    },
    getImagesImage2: function getImagesImage2(row) {
      if (JSON.parse(row.marriageCertificateImage).length === 0 || row.marriageCertificateImage.indexOf('null') !== -1) {
        return '';
      }
      var url = JSON.parse(row.marriageCertificateImage)[0].url;
      return this.downloadUrl + url;
    },
    getImagesImages2: function getImagesImages2(row) {
      var _this2 = this;
      var images = JSON.parse(row.marriageCertificateImage);
      var urls = [];
      images.forEach(function (img) {
        urls.push(_this2.downloadUrl + img.url);
      });
      return urls;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this3.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.daleteApi(index, data);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                cashBackId: data.cashBackId
              };
              _context2.n = 1;
              return api.DELETE_AGENTCASHBACK(par);
            case 1:
              _this5.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.DELETE_BATCH_AGENTCASHBACK(par);
            case 1:
              _this6.$message.success('操作成功');
              _this6.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    initCitys: function initCitys() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context4.v;
              _this7.citys = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this8 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this8.tableSelects.forEach(function (element) {
          par.push(element.cashBackId);
        });
        _this8.deleteBatchApi(par);
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.selectForm.createTimes = [];
      this.selectForm.selectCitys = [];
      this.selectForm.memberNo = '';
      this.pageNo = 1;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                pageNo: _this9.pageNo,
                pageSize: _this9.pageSize,
                selectCitys: _this9.selectForm.selectCitys,
                memberNo: _this9.selectForm.memberNo
              };
              if (_this9.selectForm.createTimes.length >= 2) {
                par.createStartTime = _this9.selectForm.createTimes[0];
                par.createEndTime = _this9.selectForm.createTimes[1];
              }
              _context5.n = 1;
              return api.GET_AGENTCASHBACK_PAGE_LIST(par);
            case 1:
              res = _context5.v;
              _this9.tableData = res.body.datas;
              _this9.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initCitys();
    this.initTableData();
  }
};